export default {"src":"/_next/static/media/cove.06593df1.svg","height":18,"width":54,"blurWidth":0,"blurHeight":0};